import { render } from "./Sections.vue?vue&type=template&id=4835690c&scoped=true"
import script from "./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue?vue&type=script&lang=js"

import "./Sections.vue?vue&type=style&index=0&id=4835690c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4835690c"

export default script